import * as Types from '../types-api.generated';

import { ListableNftFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiCollectionListableNftsVariables = Types.Exact<{
  collection: Types.ApiCollectionInput;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiCollectionListableNfts = { collectionListableNfts: { page: number, totalPages: number, totalItems: number, items: Array<{ assetUrl: string | null, name: string | null, contractAddress: Address, tokenId: number, id: string }> } | null };



export const ApiCollectionListableNftsDocument = /*#__PURE__*/ `
    query CollectionListableNfts($collection: CollectionInput!, $page: Int, $perPage: Int) {
  collectionListableNfts: collectionListableNftsV2(
    collection: $collection
    page: $page
    perPage: $perPage
  ) {
    items {
      ...ListableNftFragment
    }
    page
    totalPages
    totalItems
  }
}
    ${ListableNftFragment}`;

export const useCollectionListableNfts = <
      TData = ApiCollectionListableNfts,
      TError = ClientError
    >(
      variables: ApiCollectionListableNftsVariables,
      options?: Omit<UseQueryOptions<ApiCollectionListableNfts, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiCollectionListableNfts, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiCollectionListableNfts, TError, TData>(
      {
    queryKey: ['CollectionListableNfts', variables],
    queryFn: apiFetcher<ApiCollectionListableNfts, ApiCollectionListableNftsVariables>(ApiCollectionListableNftsDocument, variables),
    ...options
  }
    )};

useCollectionListableNfts.getKey = (variables: ApiCollectionListableNftsVariables) => ['CollectionListableNfts', variables];

export const useInfiniteCollectionListableNfts = <
      TData = InfiniteData<ApiCollectionListableNfts>,
      TError = ClientError
    >(
      variables: ApiCollectionListableNftsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiCollectionListableNfts, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiCollectionListableNfts, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiCollectionListableNfts, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionListableNfts.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiCollectionListableNfts, ApiCollectionListableNftsVariables>(ApiCollectionListableNftsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionListableNfts.getKey = (variables: ApiCollectionListableNftsVariables) => ['CollectionListableNfts.infinite', variables];


useCollectionListableNfts.fetcher = (variables: ApiCollectionListableNftsVariables, options?: RequestInit['headers']) => apiFetcher<ApiCollectionListableNfts, ApiCollectionListableNftsVariables>(ApiCollectionListableNftsDocument, variables, options);
